var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-wrapper"},[_c('h6',{staticClass:"title"},[_vm._v("合作伙伴")]),_c('div',{staticClass:"logo-box flex-center"},_vm._l((_vm.imglist),function(item,index){return _c('div',{staticClass:"items"},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }